import { useState } from 'react';
import { Button } from './ui/button';
import { MessageSquare, FileText, MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { homeTranslations } from '../translations/home';
import Bitrix24Modal from './Bitrix24Modal';

const CTASection = () => {
  const { language } = useLanguage();
  const t = homeTranslations[language].cta;
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section id="contact" className="py-24 bg-gradient-to-b from-gray-900 to-black relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 opacity-80">
        <img 
          src="/images/home/cta-bg.jpg"
          alt="DSI Industrial Equipment"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/80 to-black/60"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          {t.title}{' '}
          <span className="text-[#B91C1C]">{t.titleAccent}</span>
        </h2>
        
        {/* Subtitle */}
        <p className="text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl mx-auto">
          {t.subtitle}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Button 
            size="lg"
            onClick={() => setIsModalOpen(true)}
            className="bg-[#B91C1C] hover:bg-[#991B1B] text-white px-10 py-7 text-lg font-semibold  shadow-xl shadow-[#B91C1C]/40"
          >
            <FileText className="mr-2" size={22} />
            {t.button1}
          </Button>
          <Button 
            size="lg"
            onClick={() => window.open('https://wa.me/526181719959?text=Hola,%20me%20interesa%20información%20sobre%20sus%20servicios%20industriales', '_blank')}
            className="bg-[#25D366] hover:bg-[#20BA5A] text-white px-10 py-7 text-lg font-semibold  shadow-xl shadow-[#25D366]/40"
          >
            <MessageCircle className="mr-2" size={22} />
            WhatsApp
          </Button>
        </div>

        {/* Contact Information Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16">
          {/* Email Card */}
          <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-6 backdrop-blur-sm ">
            <h3 className="text-white font-semibold mb-2">{t.email}</h3>
            <a href={`mailto:${t.emailAddress}`} className="text-[#B91C1C] hover:text-[#991B1B]  text-lg">
              {t.emailAddress}
            </a>
          </div>

          {/* Phone Card */}
          <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-6 backdrop-blur-sm ">
            <h3 className="text-white font-semibold mb-2">{t.phone}</h3>
            <p className="text-gray-300 text-sm">{t.phoneDesc}</p>
          </div>
        </div>
      </div>
    </section>

    {/* Bitrix24 Modal */}
    <Bitrix24Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default CTASection;
